export const createEntry = state => ({
  state,
  meta: {
    lastUpdatedAt: Date.now()
  }
});

/**
 * Given the current entity, current cache entry, and next state, produces the
 * cache entry for that state.
 *
 * Behavior:
 * - returns undefined if both current entry and next state are undefined
 * - returns the current reference if only the next state is undefined
 * - returns the current reference if neither data nor flags changed
 * - returns a new reference w/ current data reference if the data has not semantically changed
 * - returns a new reference w/ new data reference if the data has semantically changed
 *
 */
export const produceNextCacheEntry = ({
  entityRegistry,
  instanceKey,
  currentEntry,
  nextState
}) => {
  const entity = entityRegistry.getEntity(instanceKey);

  // Always produce new entry if nothing currently in cache
  if (!currentEntry) {
    return createEntry(nextState);
  }

  // If next state has identical reference, return the current entry
  if (nextState === currentEntry.state) {
    return currentEntry;
  }
  const didFlagsChange = currentEntry.state.loading !== nextState.loading || currentEntry.state.stale !== nextState.stale || currentEntry.state.error !== nextState.error;
  const didDataChange = !currentEntry.state.data || !nextState.data || currentEntry.state.data !== nextState.data && entity.hasChanged(currentEntry.state.data, nextState.data);

  // If neither data or flags changed, return the current entry
  if (!didDataChange && !didFlagsChange) {
    return currentEntry;
  }

  // don't mutate our input
  const clonedState = Object.assign({}, nextState);

  // Preserve the data's reference if it hadn't actually changed
  if (!didDataChange) {
    clonedState.data = currentEntry.state.data;
  }
  return createEntry(clonedState);
};